import { render, staticRenderFns } from "./OfficeItem.vue?vue&type=template&id=85b1c9be&scoped=true&"
import script from "./OfficeItem.vue?vue&type=script&lang=js&"
export * from "./OfficeItem.vue?vue&type=script&lang=js&"
import style0 from "./OfficeItem.vue?vue&type=style&index=0&id=85b1c9be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1c9be",
  null
  
)

export default component.exports